import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import PropTypes from "prop-types"
import { useEffect } from "react"

import FontAwesomeIcon from "components/font-awesome-icon"
import Modal, { closeModal } from "components/modal"
import {
  Actions,
  SelectButton,
} from "components/HalfModal/hm-styled-components"
import ChoiceOptions from "areas/product/jewlr/wizard-options/choice-options"
import { Box } from "components/common"
import withEngravings from "areas/product/hoc/with-engravings"
// import RingWidthOptions from "areas/product/jewlr/wizard-options/ring-width-options"

const SwitchOptionsModal = ({
  choices,
  addToCart,
  isAddingToCart,
  wizardData,
  selectedValue,
  forcePanelIndex,
}) => {
  // get the first choice option with error
  let pref = Object.keys(choices).find(
    (pref) => !!choices[pref].error && /o[0-9]+/.test(choices[pref].pref)
  )
  if (!pref) {
    return null
  }

  return (
    <Modal
      label={
        wizardData[pref]
          ? wizardData[pref].options_display_labels[pref]
          : "Options"
      }
      onClose={() => {
        forcePanelIndex(pref)
        closeModal()
      }}
      show="#switch-options"
    >
      <Box pl="4px">
        <ChoiceOptions pref={pref} />
      </Box>
      <Actions>
        <SelectButton
          onClick={(e) => {
            addToCart(e, isAddingToCart)
          }}
          selected={selectedValue}
        >
          <div>
            Continue{" "}
            {isAddingToCart ? <FontAwesomeIcon icon={faSpinner} spin /> : ""}
          </div>
        </SelectButton>
      </Actions>
    </Modal>
  )
}

SwitchOptionsModal.propTypes = {
  choices: PropTypes.object,
  forcePanelIndex: PropTypes.func,
}

export default withEngravings(SwitchOptionsModal)
